/**
 * RailCard.tsx
 *
 * The DESIGN.md card recipe (`bg-surface rounded-lg border border-border
 * p-4`), reused as the rail's building block — Weekly Quests, League,
 * Parent link, Notifications etc. all sit in one of these.
 */

import type { ReactNode } from 'react';

interface RailCardProps {
  title?: string;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
}

export default function RailCard({ title, action, children, className = '' }: RailCardProps) {
  return (
    <div className={`bg-surface rounded-lg border border-border p-4 ${className}`}>
      {(title || action) && (
        <div className="flex items-center justify-between mb-3">
          {title && <p className="text-base font-bold text-content">{title}</p>}
          {action}
        </div>
      )}
      {children}
    </div>
  );
}
